import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ApplicationState } from "../store";

export const useButtonText = () => {
    const { t: tLang } = useTranslation();
    const query = new URLSearchParams(location.search);
    const LookupType = query.get("Type");
    const Gndrll = query.get("GNDNRLL");
    const lookUpTypes = ["WALKUP", "SSSOFFER"];
    const isWhiteLabeled: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.isWhiteLabeled
            ? state.configurationState.configuration.partnerConfig.isWhiteLabeled
            : false
    );
    return typeof (LookupType) == "string" && (lookUpTypes.includes(LookupType.toUpperCase()) || (Gndrll && Gndrll.includes('PSS') && !isWhiteLabeled)) ? [tLang("registration.continueButtonText"), tLang("registration.backButtonText")] : [tLang("registration.nextButtonText"), tLang("registration.previousButtonText")];
}
